import axios from 'axios';
import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import { ProjectConfig } from 'Global';
import TopBar from 'elements/TopBar/TopBar';
import FiltersApplied from 'elements/Filters/FiltersApplied';
import Cookies from 'universal-cookie';
import { getOracionesLabel } from 'hooks/useLabels';
import BookmarkIcon from '@mui/icons-material/Bookmark';
import BookmarkBorderIcon from '@mui/icons-material/BookmarkBorder';

const cookies = new Cookies();

export default function OracionesCategoryList(props: any) {

  //userChecks {} any
  const [userChecks, setUserChecks] = useState<any>({
    acuerdos:[],
    constituciones:[],
    oraciones:[]
  });

  /*================================================
  GET USER_CHECKS
  =================================================*/
  useEffect(() => {
    props.setLoading(true);
    axios.get(ProjectConfig.api_url,
    {
      params: {
        request: 'user_checks',
        user_id: cookies.get('user_id')
      }
    })
      .then((response) => {
        console.log("uc",response);
        setUserChecks(response.data);
        props.setLoading(false);
      })
      .catch((err) => {
        console.log(err.data);
      })
  }, [])
  /*================================================*/

  /*================================================
  FILTERS
  =================================================*/
  const filters = [
    { type: "text", label: "Nombre", name: "title", value: "" },
  ]
  const [filtersValues, setFiltersValues] = useState<any>({});

  const setFilters = (tempFilters: any) => {
    setFiltersValues(tempFilters);
  }
  /*================================================= 
  ==================================================*/

  interface CategoryItem {
    oraciones_category_id: number;
    title: string;
  }

  const [list, setList] = useState<CategoryItem[]>([]);
  const user_id = cookies.get('user_id');
  const lang_id = localStorage.getItem('lang_id') || '1';

  const modulo = 'Oraciones';

  /*=========================================================
  LOAD CATEGORY LIST            
  =========================================================*/

  useEffect(() => {
    props.setLoading(true);
    axios.get(ProjectConfig.api_url,
      {
        params: {
          request: 'oraciones_category_list',
          filters: filtersValues,
          page: 1,
          full_list: true,
          user_id: user_id,
          modulo: modulo,
          lang_id: lang_id
        }
      })
      .then((response) => {
        console.log("Categorías:", response.data);
        setList(response.data.list || [])
        props.setLoading(false);
      })
      .catch((err) => {
        console.log(err.data);
        props.setLoading(false);
      })

  }, [filtersValues, lang_id])
  /*=========================================================*/

  /*=========================================================
  HANDLE BOOKMARK CHECK      
  =========================================================*/

  const handleBookmark = (category_id: any) => {
    const oraciones = userChecks.oraciones || [];
    if(oraciones.includes(category_id)){
      setUserChecks({
        ...userChecks,
        oraciones: oraciones.filter((item: any) => item !== category_id)
      })
    }
    else{
      setUserChecks({
        ...userChecks,
        oraciones: [...oraciones, category_id]
      })
    }
    setTriggerUpdate(true)
  }

  /*=========================================================*/

  /*=========================================================
  UPLOAD USER_CHECKS      
  =========================================================*/

  const [triggerUpdate, setTriggerUpdate] = useState(false);
  
  useEffect(() => {
    if(triggerUpdate){
      props.setLoading(true);
      axios.post(ProjectConfig.api_url, null,
        {
          params: {
            request: 'update_user_checks',
            user_id: cookies.get('user_id'),
            userChecks: userChecks
          }
        })
          .then((response) => {
            setTriggerUpdate(false)
            props.setLoading(false);
          })
          .catch((err) => {
            console.log(err.data);
          })
    }
  }, [triggerUpdate])
  /*=========================================================*/

  return (
    <div id='OracionesCategories' className='module_container'>

      <div className="module_topBar">
        <TopBar title={getOracionesLabel('oraciones_titulo')} filters={filters} setFilters={setFilters} />
      </div>

      <FiltersApplied filtersValues={filtersValues} setFiltersValues={setFiltersValues} />

      <div className='module_content'>
        <div id="task_list_container" className="flex_column">

          {list.map((list_item, key) => {
            return (
              <div className='CardChecker' key={key}>    

                  <Link className='CardChecker_title' to={`/oraciones/categoria/${list_item.oraciones_category_id}`}
                  onClick={()=> {props.setLoading(true)}}>
                    <span className='CardListTitle'>{list_item.title}</span>
                  </Link>

                  <div className="bookmarkContainer">
                    {userChecks.oraciones && userChecks.oraciones.includes(list_item.oraciones_category_id) ?
                      <BookmarkIcon className="bookmark" onClick={()=>handleBookmark(list_item.oraciones_category_id)} /> : 
                      <BookmarkBorderIcon className="bookmark" onClick={()=>handleBookmark(list_item.oraciones_category_id)} />
                    }
                  </div>
              </div>
          )})
          }

        </div>
      </div>
    </div>
  );
};
